import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import { useNotices } from 'state';
import {
  View,
  MessageList,
  InfoMessageBlock,
  Modal,
  NoticeView,
} from 'components';
import { useState } from 'react';
import styles from './NoticesAdminScreen.module.scss';

/**
 * NoticesAdminScreen
 *
 * @return {JSX.Element}
 */
const NoticesAdminScreen = ({ className }) => {
  const {
    mapped: { adminData },
  } = useNotices();
  const messages = adminData;

  const [openMessages, setOpenMessages] = useState(null);

  const handleClick = (notice) => setOpenMessages(notice);

  const handleCLose = () => setOpenMessages(null);

  return (
    <View
      className={classNames(
        styles.NoticesAdminScreen,
        className,
        `${NoticesAdminScreen.displayName}`
      )}
    >
      {messages.length ? (
        <>
          <MessageList messages={messages} onClick={handleClick} />
          {openMessages ? (
            <Modal
              onClose={handleCLose}
              scrollContainer
              noPadding
              title="Notice"
              showCloseButton
            >
              <NoticeView notice={openMessages} />
            </Modal>
          ) : null}
        </>
      ) : (
        <InfoMessageBlock
          icon="hand"
          title="This is your notice area"
          description="It's where you'll receive updates on events from tenants"
        />
      )}
    </View>
  );
};

NoticesAdminScreen.displayName = 'NoticesAdminScreen';

export default observer(NoticesAdminScreen);
